<template>
  <div class="company-page">
    <BannerPages
      :title="'company.banner.title1'"
      :descriptions="[
        $t('company.banner.subTitle1'),
        $t('company.banner.subTitle2')
      ]"
      :img="/* locale === 'pt-br' ? '/images/company/02.Company-Img1-br.png'  
      :locale === 'ja' ? '/images/company/About-us-Jap-01.png'
      :locale === 'zh' ? '/images/company/02.Company-Img1-Ch.png'
      :locale === 'ko' ? '/images/company/02.Company-Img1-Kor.png'
      : ['LATAM'].includes(regulation) || locale === 'es' ? '/images/company/02.Company-Img1-mx.png'
      :  */'/images/company/Tim-Banner-EU.png'"
      mainImageWidthDesk="827"
      mainImageHeightDesk="762"
      alt="Tradeview CEO, Timothy Furey"
    />
    <LazyDiscoverDifference :style="degrade"/>
    <!-- <LazyTeamExperts :cards="teamCards" :title="$t('company.teamExperts.title')" :subtitle="$t('company.teamExperts.subtitle')" v-if="regulation !== 'LATAM' && $i18n.locale !== 'ja'" /> -->
    <LazyTradeviewEvolution />
    <LazyWhyChoose :why-choose-sub-title="$t('company.why-choose.subTitle')" />
    <!-- <LazyWhyOthersLike title="company.why-others-like.title" /> -->
    <LazyMoreResource :titleH2="'forms_and_documents.protectedTitle'" :cards="cards" class="with-icons" />
    <LazyTrustUs view="company" />
    <!-- <LazyAwards :data="awards"/> -->
    <client-only>
      <LazyInvestment
        :label="'company.investment.title'"
        :buttonConfigs="[
          {
            type: 'external',
            href: getExternalUrl('/register/1/live-account'),
            class: 'primary-button-medium',
            textKey: 'investment.link'
          }
        ]"
      />
    </client-only>
  </div>
</template>

<script setup>
import LazyDiscoverDifference from '~/components/company/DiscoverDifference';
import LazyMoreResource from '~/components/home/MoreResource';
import LazyTeamExperts from '~/components/company/team-experts';
import LazyTradeviewEvolution from '~/components/company/TradeviewEvolution';
import LazyAwards from '~/components/home/Awards';
import LazyWhyChoose from '~/components/company/WhyChoose';
import LazyWhyOthersLike from '~/components/company/WhyOthersLike';
import LazyTrustUs from '~/components/home/TrustUs';

import { useI18n } from 'vue-i18n';
import { useExternalUrl } from '@/composables/useExternalUrl';
import { useImage } from '#imports'; 

const { t, locale } = useI18n();
const { getExternalUrl } = useExternalUrl();
const { $regulationsVar } = useNuxtApp();

const regulation = ref($regulationsVar.getRegulation(locale.value));
const nuxtImg = useImage();

const title = t('seo.company.title');
const description = t('seo.company.description');
const imgSeo = 'https://tradeview.eu/images/seo/04AboutUs.jpg'

useSeoMeta({
  title: title,
  ogTitle: title,
  twitterTitle: title,
  description: description,
  ogDescription: description,
  twitterDescription: description,
  ogImage: imgSeo,
  twitterImage: imgSeo
});

const degradadeImageUrl = '/images/company/Gradient5.avif';
const degradade2ImageUrl = '/images/company/Company-Gradient.avif';
const degradade3ImageUrl = '/images/company/Company-Gradient2.avif';
const degradade4ImageUrl = '/images/company/Company-Gradient3.avif';

const optimizedDegrade = nuxtImg(degradadeImageUrl, {
  quality: 50,
  format: 'avif',
});
const optimizedDegrade2 = nuxtImg(degradade2ImageUrl , {
  quality: 50,
  format: 'avif',
});
const optimizedDegrade3 = nuxtImg(degradade3ImageUrl, {
  quality: 50,
  format: 'avif',
});
const optimizedDegrade4 = nuxtImg(degradade4ImageUrl , {
  quality: 50,
  format: 'avif',
});

const degrade = computed(() => {
  return {
    '--degrade': `url('${optimizedDegrade}')`,
    '--degrade2': `url('${optimizedDegrade2}')`,
  };
});

const degrade3 = computed(() => {
  return {
    '--degrade3': `url('${optimizedDegrade3}')`,
    '--degrade4': `url('${optimizedDegrade4}')`,
  };
});

const cards = ref([
  {
    icon: 'sync',
    title: 'forms_and_documents.protectedCardTitle1',
    desc: 'forms_and_documents.protectedCardDesc1',
  },
  {
    icon: 'account_balance_wallet',
    title: 'forms_and_documents.protectedCardTitle2',
    desc: 'forms_and_documents.protectedCardDesc2',
  },
  {
    icon: 'lock',
    title: 'forms_and_documents.protectedCardTitle3',
    desc: 'forms_and_documents.protectedCardDesc3',
  },
  {
    icon: 'acute',
    title: 'forms_and_documents.protectedCardTitle4',
    desc: 'forms_and_documents.protectedCardDesc4',
  },
]);
const awards = ref({
  titlecont: "awards.titlecont",
  descriptcont: "awards.descriptcont",
  cards: [
    { imgSrc: '/images/award/awar-19.svg', alt: 'Best CFDs Broker', title: 'awards.titlecard19', subtitle: 'awards.subtitlecard19', location: 'awards.location19' },
    { imgSrc: '/images/award/awar-18.svg', alt: 'Best Customer Service', title: 'awards.titlecard18', subtitle: 'awards.subtitlecard18', location: 'awards.location18' },
    { imgSrc: '/images/award/awar-17.svg', alt: 'Best International Stocks Broker', title: 'awards.titlecard17', subtitle: 'awards.subtitlecard17', location: 'awards.location17' },
    { imgSrc: '/images/award/awar-16.svg', alt: 'Best Customer Service', title: 'awards.titlecard16', subtitle: 'awards.subtitlecard16', location: 'awards.location16' },
    { imgSrc: '/images/award/awar-15.svg', alt: 'Best International Stocks Broker', title: 'awards.titlecard15', subtitle: 'awards.subtitlecard15', location: 'awards.location15' },
    { imgSrc: '/images/award/awar-14.svg', alt: 'Top Regulated Forex Broker', title: 'awards.titlecard14', subtitle: 'awards.subtitlecard14', location: 'awards.location14' },

    { imgSrc: '/images/award/awar-13.svg', alt: 'Best Multi-Asset Broker', title: 'awards.titlecard13', subtitle: 'awards.subtitlecard13', location: 'awards.location13' },
    { imgSrc: '/images/award/awar-12.svg', alt: 'Highest Value Broker', title: 'awards.titlecard12', subtitle: 'awards.subtitlecard12', location: 'awards.location12' },
    /* { imgSrc: '/images/award/awar-7.svg', alt: 'Best Islamic Account', title: 'awards.titlecard7', subtitle: 'awards.subtitlecard7', location: 'awards.location7' }, */
    { imgSrc: '/images/award/awar-8.svg', alt: 'Best CEO ', title: 'awards.titlecard8', subtitle: 'awards.subtitlecard8', location: 'awards.location8' },
    { imgSrc: '/images/award/awar-9.svg', alt: 'Top 100 FX Companies', title: 'awards.titlecard9', subtitle: 'awards.subtitlecard9', location: 'awards.location9' },
    { imgSrc: '/images/award/awar-10.svg', alt: 'Best Forex Broker', title: 'awards.titlecard10', subtitle: 'awards.subtitlecard10', location: 'awards.location10' },
    { imgSrc: '/images/award/awar-11.svg', alt: 'Best International Broker for Stocks', title: 'awards.titlecard11', subtitle: 'awards.subtitlecard11', location: 'awards.location11' },
    { imgSrc: '/images/award/awar-1.svg', alt: 'Innovative Trading Partner', title: 'awards.titlecard1', subtitle: 'awards.subtitlecard1', location: 'awards.location1' },
    { imgSrc: '/images/award/awar-2.svg', alt: 'Most Transparent Broker', title: 'awards.titlecard2', subtitle: 'awards.subtitlecard2', location: 'awards.location2' },
    { imgSrc: '/images/award/awar-3.svg', alt: 'Lowest Trading Costs Broker', title: 'awards.titlecard3', subtitle: 'awards.subtitlecard3', location: 'awards.location3' },
    { imgSrc: '/images/award/awar-4.svg', alt: 'Most Trusted Broker', title: 'awards.titlecard4', subtitle: 'awards.subtitlecard4', location: 'awards.location4' },
    { imgSrc: '/images/award/awar-5.svg', alt: 'Best ETF Broker', title: 'awards.titlecard5', subtitle: 'awards.titlecard5', location: 'awards.location5' },
    { imgSrc: '/images/award/awar-6.svg', alt: 'Best Forex Trading Experience', title: 'awards.titlecard6', subtitle: 'awards.subtitlecard6', location: 'awards.location6' },
  ],
});

const teamCards = [
  {
    image: '/images/company/Timothy-Furey-desktop-1.png',
    imageMobile: '/images/company/Timothy-Furey-desktop-2.png',
    topImage: '/images/company/Timothy-Furey-desktop-2.png', 
    name: t('company.teamExperts.members.expert1.name'),
    position: t('company.teamExperts.members.expert1.position'),
    description: t('company.teamExperts.members.expert1.description'),
    links: [
      {
        url: 'https://www.linkedin.com/in/timfurey/',
        image: '/images/company/linkedin-icon.svg',
        alt: 'LinkedIn',
      },
      {
        url: 'https://www.instagram.com/timfurey.ceo/',
        image: '/images/company/instagram-icon.svg',
        alt: 'Instagram',
      },
      {
        url: 'https://x.com/timfurey?s=11',
        image: '/images/company/x-icon.svg',
        alt: 'Twitter',
      },
    ],
  },
  {
    image: '/images/company/Ben-Sadgrove-desktop-1.png',
    imageMobile: '/images/company/Ben-Sadgrove-desktop-2.png',
    topImage: '/images/company/Ben-Sadgrove-desktop-2.png', 
    name: t('company.teamExperts.members.expert2.name'),
    position: t('company.teamExperts.members.expert2.position'),
    description: t('company.teamExperts.members.expert2.description'),
    links: [
      {
        url: 'https://www.linkedin.com/in/bensadgrove/',
        image: '/images/company/linkedin-icon.svg',
        alt: 'LinkedIn',
      },
    ],
  },
  {
    image: '/images/company/Michael-Lombardo-desktop-1.png',
    imageMobile: '/images/company/Michael-Lombardo-desktop-2.png',
    topImage: '/images/company/Michael-Lombardo-desktop-2.png', 
    name: t('company.teamExperts.members.expert3.name'),
    position: t('company.teamExperts.members.expert3.position'),
    description: t('company.teamExperts.members.expert3.description'),
    links: [
      {
        url: 'https://www.linkedin.com/in/milombardo/',
        image: '/images/company/linkedin-icon.svg',
        alt: 'LinkedIn',
      },
    ],
  },
  {
    image: '/images/company/Andrea-Lafleche-desktop-1.png',
    imageMobile: '/images/company/Andrea-Lafleche-desktop-2.png',
    topImage: '/images/company/Andrea-Lafleche-desktop-2.png', 
    name: t('company.teamExperts.members.expert4.name'),
    position: t('company.teamExperts.members.expert4.position'),
    description: t('company.teamExperts.members.expert4.description'),
    links: [
      {
        url: 'https://www.linkedin.com/in/andrealafleche/',
        image: '/images/company/linkedin-icon.svg',
        alt: 'LinkedIn',
      },
    ],
  },
  {
    image: '/images/company/Andy-MacDonald-desktop-1.png',
    imageMobile: '/images/company/Andy-MacDonald-desktop-2.png',
    topImage: '/images/company/Andy-MacDonald-desktop-2.png', 
    name: t('company.teamExperts.members.expert5.name'),
    position: t('company.teamExperts.members.expert5.position'),
    description: t('company.teamExperts.members.expert5.description'),
    links: [
      {
        url: 'https://www.linkedin.com/in/andy-macdonald-47681692/',
        image: '/images/company/linkedin-icon.svg',
        alt: 'LinkedIn',
      },
    ],
  },
  {
    image: '/images/company/Evanio-Carvalho-dekstop-1.png',
    imageMobile: '/images/company/Evanio-Carvalho-dekstop-2.png',
    topImage: '/images/company/Evanio-Carvalho-dekstop-2.png', 
    name: t('company.teamExperts.members.expert6.name'),
    position: t('company.teamExperts.members.expert6.position'),
    description: t('company.teamExperts.members.expert6.description'),
    links: [
      {
        url: 'https://www.linkedin.com/in/evanio-petnys-de-carvalho/',
        image: '/images/company/linkedin-icon.svg',
        alt: 'LinkedIn',
      },
    ],
  },
  {
    image: '/images/company/Kirk-R-Miller-desktop-1.png',
    imageMobile: '/images/company/Kirk-R-Miller-desktop-2.png',
    topImage: '/images/company/Kirk-R-Miller-desktop-2.png', 
    name: t('company.teamExperts.members.expert7.name'),
    position: t('company.teamExperts.members.expert7.position'),
    description: t('company.teamExperts.members.expert7.description'),
    links: [
      {
        url: 'https://www.linkedin.com/in/kirkrmiller/',
        image: '/images/company/linkedin-icon.svg',
        alt: 'LinkedIn',
      },
    ],
  },
];
</script>
